<template>
    <section>
        <DaumPostCode :open="showDaumPostCode" @selected="onAddressSelected" />
    </section>
</template>

<script>
    import DaumPostCode from '../components/DaumPostCode'
    import { useRoute } from 'vue-router'
    export default {
        name: "Checkout",
        components: {
            DaumPostCode,
        },
        data: function () {
            const route = useRoute()
            const { query } = route
            return {
                showDaumPostCode : false
            }
        },
        methods: {
            async update() {
                this.showDaumPostCode = true
            },
            onAddressSelected(item = {zonecode: 0, addr: '', extraAddr: ''}){
                this.showDaumPostCode = false
                console.log('item', item)
                if(!item.zonecode){
                    return
                }
                
                this.post = item.zonecode
                this.address = item.addr + ' ' + item.extraAddr
                this.address_detail = '2동2호'
                // this.paramsAdditional.studioAddress = {
                //     ...this.paramsAdditional.studioAddress,
                //     ...item,
                // }
            },
        },
        async mounted() {
            this.update();
        },
    }
</script>

<style scoped>

</style>
